module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Series#fm-1"
    }
  }, [_vm._v("Series Editor’s Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Abbre#fm-2"
    }
  }, [_vm._v("List of Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Bib#fm-3"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#ch-1"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('table', {
    staticClass: "tab"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "toc-sec1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-1"
    }
  }, [_vm._v("I.")])])]), _c('td', [_c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-1"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACKGROUND")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-sec1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-2"
    }
  }, [_vm._v("II.")])])]), _c('td', [_c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-2"
    }
  }, [_vm._v("U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITY OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMPOSITION")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _c('td', [_c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-1"
    }
  }, [_vm._v("A. The Unity and Interrelationship of the Poems")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _c('td', [_c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-2"
    }
  }, [_vm._v("B. Poetic Form in the Poems")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _c('td', [_c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-3"
    }
  }, [_vm._v("C. The Relationship between the Cola")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _c('td', [_c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-4"
    }
  }, [_vm._v("D. Repetition, Terseness, Imagery, Point of View, Genre")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-sec1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-3"
    }
  }, [_vm._v("III.")])])]), _c('td', [_c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-3"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTHORSHIP AND")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATE")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-sec1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-4"
    }
  }, [_vm._v("IV.")])])]), _c('td', [_c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-3"
    }
  }, [_vm._v("O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CCASION")]), _vm._v(", P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LACE OF")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIGIN, AND")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESTINATION")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-sec1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-5"
    }
  }, [_vm._v("V.")])])]), _c('td', [_c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-3"
    }
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANONICITY")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _c('td', [_c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-5"
    }
  }, [_vm._v("A. The Canonical Process")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _c('td', [_c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-6"
    }
  }, [_vm._v("B. The Bounds and the Order of the Canon")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-sec1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-6"
    }
  }, [_vm._v("VI.")])])]), _c('td', [_c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-6"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EBREW")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXT")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-sec1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-7"
    }
  }, [_vm._v("VII.")])])]), _c('td', [_c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-6"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEOLOGY")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-sec1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-8"
    }
  }, [_vm._v("VIII.")])])]), _c('td', [_c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-6"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AIN")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEMES AND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEIR")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MPLICATIONS")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _c('td', [_c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-7"
    }
  }, [_vm._v("A. The Explosion of Interest")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  })]), _c('td', [_c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec2-8"
    }
  }, [_vm._v("B. Theodicy and Antitheodicy")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc-sec1"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-9"
    }
  }, [_vm._v("IX.")])])]), _c('td', [_c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Chapter01#sec-9"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NALYSIS OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#ch-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TEXT AND COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMENTATIONS")]), _vm._v(" 1: “I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HERE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AIN")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IKE")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Y")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AIN")]), _vm._v("?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMENTATIONS")]), _vm._v(" 2: “H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURED")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UT")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IS")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RATH")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IKE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRE")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02a#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMENTATIONS")]), _vm._v(" 3: “P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERHAPS")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HERE")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("S")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OPE")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02a#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMENTATIONS")]), _vm._v(" 4: “H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v(" L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IT A")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IRE IN")]), _vm._v(" Z"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ION")]), _vm._v("”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter02a#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMENTATIONS")]), _vm._v(" 5: “B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("E")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INDFUL")]), _vm._v(", Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AHWEH")]), _vm._v("”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27bbe38a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005_Contents.vue
// module id = 69
// module chunks = 0